// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash/fp';

// Utils
import { chooseSingular, pluralise } from '../../../../../../../common/utils/stringUtil';
import {
    getNotificationAssignmentsAsArray,
    getNotificationAssignmentText,
} from '../../../../../../../common/notifications/notificationModelUtils';

// Components
import BaseNotificationEntry from './BaseNotificationEntry';
import UserNames from './UserNames';
import StandardNotificationBoardTitle from './StandardNotificationBoardTitle';
import NotificationUserFigure from './NotificationFigureUser';
import Icon from '../../../../../../components/icons/Icon';

// Styles
import './NotificationEntryAssignment.scss';

const getFilteredAssignments = (notification) => {
    const assignments = getNotificationAssignmentsAsArray(notification);
    return assignments.filter((assignment) => {
        const text = getNotificationAssignmentText(assignment);
        return !isEmpty(text);
    });
};

const AssignmentEntries = ({ assignments }) => {
    if (isEmpty(assignments)) return null;

    const entriesText = assignments.map(getNotificationAssignmentText);

    return (
        <ul className="AssignmentEntries">
            {entriesText.map((text, index) => (
                <li key={index} className="assignment-text">
                    {text}
                </li>
            ))}
        </ul>
    );
};

AssignmentEntries.propTypes = {
    assignments: PropTypes.array,
};

const NotificationEntryAssignment = (props) => {
    const { actors, notification } = props;

    const assignments = getFilteredAssignments(notification);

    const assignmentCount = assignments.length;
    const statement =
        `assigned ${chooseSingular(assignmentCount || 1, 'a', assignmentCount)} ` +
        `${pluralise('task', assignmentCount || 1)} to you`;

    return (
        <BaseNotificationEntry
            {...props}
            className="NotificationEntryAssignment"
            figure={<NotificationUserFigure {...props} icon={<Icon name="notification-task-update" />} />}
        >
            <div className="notification-statement">
                <UserNames users={actors} /> {statement}
                <StandardNotificationBoardTitle {...props} />
                {assignmentCount ? ':' : ''}
            </div>
            <AssignmentEntries assignments={assignments} />
        </BaseNotificationEntry>
    );
};

NotificationEntryAssignment.propTypes = {
    notification: PropTypes.object,
    actors: PropTypes.array,
};

export default NotificationEntryAssignment;
